import {
  advanceTableSelectionPopupItem,
  advanceTableSelectionPopupItemText,
} from '@aibees/shared/features/advance-table/components/advanced-table-select-popup/sx';
import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = advanceTableSelectionPopupItem;

export const inputContentRow: SxStyle = {};

export const checkbox: SxStyle = {
  padding: 0,
};

export const input: SxStyle = {
  '& input': {
    textAlign: 'center',
    color: (p) => p.palette.grey[800],
  },
};

export const text: SxStyle = advanceTableSelectionPopupItemText;
